<template>
  <v-card
    class="c metrics-simple-statistic"
    :class="{'is-clickable': clickable}"
    :ripple="clickable"
  >
    <v-card-text @click="onClick">
      <div class="value" :style="`${color === 'error' ? 'color: #FF5252;' : ''}`">
        <template v-if="type === 'number'">
          <count-to
            :startVal="startVal"
            :endVal="Number(value)"
            decimal=","
            :decimals="decimals"
            :duration="1500"
            :suffix="suffix"
          ></count-to>
        </template>
        <template v-else>
          {{ value }}{{ suffix }}
        </template>
      </div>
      <div class="label">
        <v-subheader>{{ label }}</v-subheader>
      </div>
    </v-card-text>
    <div class="click-icon" v-if="clickable">
      <v-icon>{{ icon }}</v-icon>
    </div>
  </v-card>
</template>

<script>
import CountTo from 'vue-count-to';

export default {
  name: 'simple-statistic',

  components: {
    CountTo,
  },

  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'normal',
    },
    type: {
      type: String,
      default: 'number',
    },
    suffix: {
      type: String,
      default: '',
    },
    decimals: {
      type: Number,
      default: 0,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'open_in_new',
    },
  },

  data() {
    return {
      startVal: 0,
    };
  },

  watch: {
    value(newVal, oldVal) {
      this.startVal = oldVal;
    },
  },

  methods: {
    onClick() {
      this.$emit('item-click');
    },
  },
};
</script>
